import { TalentField, Category } from '../character/allValues';
import ValueAttribute from './valueAttribute';
import { AttributeExport, AttributeExportTypes } from './baseAttribute';

export interface TalentExport extends AttributeExport {
  field: string;
  value: number;
  isAvatarsTalent: boolean;
}

export default class Talent extends ValueAttribute {
  public category: Category = Category.Talent;
  public talentField: TalentField;
  public isAvatarsTalent: boolean;

  public constructor(name: string, field: TalentField) {
    super(name);
    this.isAvatarsTalent = false;
    this.talentField = field;
  }

  public getClone() {
    const clone = new Talent(this.name, this.talentField);
    clone.isAvatarsTalent = this.isAvatarsTalent;
    clone.value = this.value;

    return clone;
  }

  public export(): TalentExport {
    return {
      name: this.name,
      abbreviation: this.abbreviation,
      type: AttributeExportTypes.Talent,
      field: this.talentField,
      value: this.value,
      isAvatarsTalent: this.isAvatarsTalent,
    };
  }
}
